import React from 'react'
import { Button } from './Button'
import './HeroSection.css'
import './App.css'

function HeroSection() {
  return (
    <>
    <div className='hero-container'>
        <h1>
            Looking for a mortgage?
        </h1>
        <p>
            Call us ASAP to find the best rates for you!
        </p>
        <div className='hero-btns'>
            <Button className='btns' buttonStyle={'btn--outline'} buttonSize={'btn--large'} path={'/contact'}>
                Contact Us!
            </Button>
        </div>
    </div>
    <div className='help-container'>
        <h2>
            What we can do for you
        </h2>
        <div className='cardsWrapper'>
          <div className='card'>
            <h3 className='cardTitle'>MORTGAGE</h3>
            <div className='featureImage__container'>
              <img 
                src="/images/couple_house.jpg" 
                alt="Couple with keys" 
                className='featureImage'
              />
            </div>
            <p className='cardText'>
              I'll help you secure the best rates and terms tailored to your needs, making homeownership simple and hassle-free.
            </p>
          </div>
          <div className='card'>
            <h3 className='cardTitle'>MORTGAGE CALCULATOR</h3>
            <div className='featureImage__container'>
              <img 
                src="/images/calculator.jpg" 
                alt="Calculator" 
                className='featureImage'
              />
            </div>
            <p className='cardText'>
              Easily estimate your monthly payments with our mortgage calculator. 
              Get a clear picture of your home financing options in just a few clicks!
            </p>
          </div>
          <div className='card'>
            <h3 className='cardTitle'>ONLINE APPLICATION</h3>
            <div className='featureImage__container'>
              <img 
                src="images/mortgage_application.jpg" 
                alt="Applying online" 
                className='featureImage'
              />
            </div>
            <p className='cardText'>
              Apply for your mortgage online in minutes! A fast and hassle-free way to get started on your home financing journey
            </p>
          </div>
        </div>
    </div>
    <div className='hero__about__section'>
      <div className='leftColumnStyle'>
        <h1 className='headingStyle'>SHAWN JALALI</h1>
        <p className='paragraphStyle'>
          Navigating the mortgage process can feel overwhelming, 
          but it doesn't have to be. As an experienced mortgage agent, 
          I specialize in finding the best financing solutions tailored to your unique needs. 
          Whether you're a first-time homebuyer, refinancing your current home, or investing in property, 
          I'm here to guide you every step of the way.
        </p>
        <Button className='btns' buttonStyle={'btn--outline'} buttonSize={'btn--large'} path={'/contact'}>
            Give Me A Call!
        </Button>
      </div>
      <div className='rightColumnStyle'>
        <img
          src="/images/brokerMan2.jpg"
          alt="Man in suit holding a tablet"
          className='hero-about-img'
          // style={{ width: '100%', borderRadius: '4px' }}
        />
      </div>
    </div>
    </>
  )
}

export default HeroSection